
import { doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase"; // Adjust path if needed

const userProfileService = {
  /**
   * Create or overwrite a user profile with the required fields
   */
  createUserProfile: async (userId, profileData) => {
    const profileRef = doc(db, "users", userId, "User Profile", "Main");
    try {
      await setDoc(profileRef, {
        userId: userId,
        firstName: profileData.firstName || "",
        lastName: profileData.lastName || "",
        organization: profileData.organization || "",
        email: profileData.email || "",
        city: profileData.city || "",
        state: profileData.state || "",
        country: profileData.country || "",
        dob: profileData.dob || "",
        joinDate: profileData.joinDate || new Date().toISOString(),
        freeTrialEndDate: profileData.freeTrialEndDate || "",
      });
      console.log("✅ User profile created successfully.");
    } catch (error) {
      console.error("❌ Error creating user profile:", error);
      throw error;
    }
  },

  /**
   * Get user profile data
   */
  getUserProfile: async (userId) => {
    const profileRef = doc(db, "users", userId, "User Profile", "Main");
    try {
      const snapshot = await getDoc(profileRef);
      if (snapshot.exists()) {
        return snapshot.data();
      } else {
        console.warn("User profile not found.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      throw error;
    }
  },

  /**
   * Update specific fields in the user profile
   */
  updateUserProfile: async (userId, updates) => {
    const profileRef = doc(db, "users", userId, "User Profile", "Main");
    try {
      await updateDoc(profileRef, updates);
      console.log("✅ User profile updated successfully.");
    } catch (error) {
      console.error("❌ Error updating user profile:", error);
      throw error;
    }
  },
};

export default userProfileService;
